export default __webpack_public_path__ + "static/media/inklink exterior2.5a2b3cf6.jpg";